






import { defineComponent } from '@vue/composition-api';

import PageColumnWithLiveList from '@/components/Live/PageColumnWithLiveList.vue';

const Index = defineComponent({
  components: {
    PageColumnWithLiveList,
  },
  // setup() {},
});

export default Index;
